<template>
  <v-app class="app-dashboard" grid-list-md>
    <v-layout wrap :fill-height="false">
      <v-flex md3 xs6 class="div-main-chart">
        <v-card class="card-chart">
          <v-card-title class="pa-1 ma-1">Meta Total</v-card-title>
          <v-card-text>
            <div>Total:</div>
            <p class="display-1 text--primary">{{ cards.total_meta }}</p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 xs6 class="div-main-chart">
        <v-card class="card-chart">
          <v-card-title class="pa-1 ma-1">Meta Efetivada</v-card-title>
          <v-card-text>
            <div>Total:</div>
            <p class="display-1 text--primary">{{ cards.total_cadastro }}</p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 xs6 class="div-main-chart">
        <v-card class="card-chart">
          <v-card-title class="pa-1 ma-1">% Realizado</v-card-title>
          <v-card-text class="text-center">
            <v-progress-circular
              class="mt-n5"
              :rotate="360"
              :size="85"
              :width="15"
              :value="cards.total_percentual"
              color="primary"
              >{{ cards.total_percentual }}%</v-progress-circular
            >
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 xs6 class="div-main-chart">
        <v-card class="card-chart">
          <v-card-title class="pa-1 ma-1">Cad. Quebrados</v-card-title>
          <v-card-text>
            <div>Total:</div>
            <p
              style="cursor: pointer"
              class="display-1 text--primary"
              @click="getReportQuebrados(select_equipe)"
            >
              {{ cards.total_quebra }}
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-toolbar extended extension-height="10" class="pa-0 ma-0">
          <v-toolbar-title>Filtros :</v-toolbar-title>
          <v-flex xs4>
            <v-select
              class="pa-2 mt-10"
              v-model="select_equipe"
              :items="selects.candidatos.items"
              :disabled="selects.candidatos.ativado"
              @change="
                buscarAssessores();
                getMetas(select_equipe), buscarTotais();
              "
              outlined
              label="Equipe"
              height="10"
              item-value="idcandidato"
              item-text="nome_completo"
            ></v-select>
          </v-flex>
          <v-flex xs4>
            <v-select
              v-model="select_meta"
              class="pa-2 mt-10"
              :items="selects.metas.items"
              @change="buscarAssessores(), buscarTotais()"
              outlined
              label="Tipo de Meta"
              height="10"
              item-value="idmeta"
              item-text="descricao"
            ></v-select>
          </v-flex>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            small
            rounded
            title="Apuração por Metas"
            style="margin-right: 15px"
            @click="getReportApuracaoMeta(select_equipe)"
          >
            <v-icon> mdi-account-group</v-icon>
          </v-btn>

          <v-btn
            color="warning"
            small
            rounded
            title="Apuração por Assessor"
            style="margin-right: 15px"
            @click="getReportApuracaoAssessor(select_equipe)"
          >
            <v-icon> mdi-tray-full </v-icon>
          </v-btn>
          <v-btn
            color="primary"
            small
            rounded
            title="Atualizar os Dados"
            @click="atualizarDados()"
          >
            <v-icon> mdi-refresh </v-icon>
          </v-btn>
        </v-toolbar>
      </v-flex>

      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="itemsWithIndex"
          :search="search"
          :items-per-page="-1"
          :fixed-header="true"
          class="elevation-1"
          height="70vh"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Lista de Assessores</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                class="mr-10"
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>

          <template v-slot:item.percentual="{ item }">
            {{ item.percentual }} %
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon
              class="mr-2"
              style="cursor: pointer"
              @click="getReportAssessor(item.id)"
              >mdi-printer</v-icon
            >
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-app>
</template>
<script>
import DashboardAPI from "./../../api/dashboard";
import AclAPI from "./../../api/acl";
import VueLazyInput from "vue-lazy-input";
import Vue from "vue";

Vue.use(VueLazyInput);

export default {
  data() {
    return {
      dialog: false,
      search: "",
      cards: {
        total_meta: 0,
        total_cadastro: 0,
        total_percentual: 0,
        total_quebra: 0,
      },
      select_equipe: 0,
      select_meta: 0,
      selects: {
        candidatos: {
          ativado: false,
          value: 0,
          items: [],
        },
        metas: {
          value: 0,
          items: [],
        },
      },
      headers: [
        { text: "Indice", value: "index" },
        {
          text: "Equipe",
          align: "start",
          value: "equipe",
        },
        {
          text: "Nome Completo",
          align: "start",
          value: "nome_completo",
        },
        { text: "Meta", value: "total_geral_meta" },
        { text: "Total de Cadastrados", value: "total_cadastrado" },
        { text: "Percentual Meta", value: "percentual" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      desserts: [],
    };
  },
  computed: {
    setarEquipe() {
      const equipe = localStorage.getItem("equipe");
      return equipe;
    },
    itemsWithIndex() {
      return this.desserts.map((items, index) => ({
        ...items,
        index: index + 1,
      }));
    },
  },
  watch: {
    buscaCandidatos() {
      this.select_equipe = this.setarEquipe;
    },
  },

  created() {
    this.Helpers.verificarToken();
    this.buscaCandidatos();
    setTimeout(() => {
      this.setEquipe();
    }, 200);
    setTimeout(() => {
      this.buscarAssessores();
      this.buscarTotais();
    }, 300);
  },
  methods: {
    buscaCandidatos() {
      const headers = this.Helpers.iniciarRequisicao();
      AclAPI.getCandidatos(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.candidatos.items = [];

          if (response.status == 200) {
            this.selects.candidatos.items = response.data.candidatos;

            let objCandidato = {
              idcandidato: "null",
              nome_completo: "TODOS",
              chapa: 0,
            };

            this.selects.candidatos.items.push(objCandidato);
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    buscarTotais() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        equipe: this.select_equipe,
        meta: this.select_meta,
      };

      DashboardAPI.getTotais(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.cards.total_meta = response.data.totais[0].total_geral_meta;
          this.cards.total_cadastro = response.data.totais[0].total_cadastrado;
          this.cards.total_percentual = response.data.totais[0].percentual;
          this.cards.total_quebra = response.data.quebra[0].total;
        })
        .catch(() => {
          this.$store.dispatch("loading/habilitarLoading", false);
          this.Helpers.logout();
        });
    },
    buscarAssessores() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        equipe: this.select_equipe,
        meta: this.select_meta,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DashboardAPI.getAssessores(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.desserts = response.data.assessores;
          })
          .catch(() => {
            this.$store.dispatch("loading/habilitarLoading", false);
            this.Helpers.logout();
          })
      );
    },
    getMetas(equipe) {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        equipe: equipe,
      };

      AclAPI.getMetas(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.metas.items = [];

          if (response.status == 200) {
            this.selects.metas.items = response.data.metas;

            let objMetas = {
              idmeta: "null",
              descricao: "TODAS",
            };

            this.selects.metas.items.push(objMetas);
            this.select_meta = "null";
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    getReportAssessor(id) {
      const equipe = localStorage.getItem("id");
      let url = "relatorio_assessores?id=" + id + "&id_cd=" + equipe;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },
    getReportQuebrados(id) {
      let url = "relatorio_quebrados?id=" + id + "&meta=" + this.select_meta;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },
    getReportApuracaoAssessor(id) {
      let url =
        "relatorio_apuracao?equipe=" +
        id +
        "&meta=" +
        this.select_meta +
        "&tipo=" +
        2 +
        "&tipo_apuracao=" +
        2;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },
    getReportApuracaoMeta(id) {
      let url =
        "relatorio_apuracao?equipe=" +
        id +
        "&meta=" +
        this.select_meta +
        "&tipo=" +
        1 +
        "&tipo_apuracao=" +
        2;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },

    setEquipe() {
      const equipe = localStorage.getItem("equipe");

      if (equipe != "null") {
        this.select_equipe = parseInt(equipe);
        this.selects.candidatos.ativado = true;
        this.getMetas(equipe);
      } else {
        this.select_equipe = "null";
        this.getMetas("null");
      }
    },
    atualizarDados() {
      this.buscarAssessores();
      this.buscarTotais();
    },
  },
};
</script>
<style scoped>
.app-dashboard {
  background-color: #e7e6eb;
  height: 160px;
}

.card-chart {
  border-radius: 5px;
  height: 110px;
}

.div-main-chart {
  padding: 0.5% 2% 2% 2%;
}
</style>
